import React, { useRef, useEffect } from "react"
import PropTypes from "prop-types"
import { TextAreaWrapper, TextArea as StyledTextArea } from "./styles"

const TextArea = ({ value, handleInputChange, ...rest }) => {
  const ref = useRef()

  const onChange = (event) => {
    const { name, value } = event.target
    if (handleInputChange !== undefined) handleInputChange(name, value)
  }

  useEffect(() => {
    ref.current.scrollTop = ref.current.scrollHeight
  }, [value])

  return (
    <TextAreaWrapper data-replicated-value={value}>
      <StyledTextArea ref={ref} value={value} onChange={onChange} {...rest} />
    </TextAreaWrapper>
  )
}

TextArea.propTypes = {
  handleInputChange: PropTypes.func.isRequired,
  showValidation: PropTypes.bool.isRequired,
  value: PropTypes.string,
  rows: PropTypes.number,
  invalid: PropTypes.bool
}

TextArea.defaultProps = {
  handleInputChange: undefined,
  showValidation: false,
  value: "",
  rows: 1,
  invalid: false
}

export default TextArea
